import { RequestStatus } from '@occc-app/lib/constants';

export type State = {
  status: RequestStatus;
  records: number;
  first?: string;
  last?: string;
  next?: string;
  prev?: string;
};

export const state: State = {
  status: RequestStatus.WAIT,
  records: 0,
};
